import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCurrencyStore, CURRENCIES } from '../../store/currencyStore';

const CurrencySelector: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { selectedCurrency, setCurrency } = useCurrencyStore();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-1 text-xs tracking-widest uppercase hover:text-nude transition-colors"
      >
        <span>{selectedCurrency.flag}</span>
        <span>{selectedCurrency.code}</span>
        <ChevronDown size={10} />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute right-0 top-8 bg-white border border-light shadow-xl w-48 z-50 max-h-64 overflow-y-auto"
          >
            {CURRENCIES.map((currency) => (
              <button
                key={currency.code}
                onClick={() => {
                  setCurrency(currency);
                  setIsOpen(false);
                }}
                className={`w-full flex items-center space-x-3 px-4 py-3 text-xs hover:bg-light transition-colors ${
                  selectedCurrency.code === currency.code
                    ? 'text-primary font-medium bg-light'
                    : 'text-secondary'
                }`}
              >
                <span className="text-base">{currency.flag}</span>
                <div className="text-left">
                  <p className="tracking-widest uppercase">{currency.code}</p>
                  <p className="text-nude text-xs">{currency.name}</p>
                </div>
                <span className="ml-auto text-nude">{currency.symbol}</span>
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CurrencySelector;